"use client";

import { PageContextProvider } from "@/context/PageContext/PageContextProvider";
import {
  useContentfulInspectorMode,
  useContentfulLiveUpdates,
} from "@contentful/live-preview/react";
import DynamicComponent from "../../components/DynamicComponent/DynamicComponent.component";
import { DynamicComponentKey } from "../../components/DynamicComponent/DynamicComponent.model";
import Logo from "../../components/Logo/Logo.component";
import { PageProps } from "./Page.model";

export default function Page({ data }: PageProps) {
  const inspectorProps = useContentfulInspectorMode({
    entryId: data?.page?.sys?.id,
  });
  const liveData = useContentfulLiveUpdates(data.page);

  const { pageContentCollection } = liveData;

  return (
    <PageContextProvider data={data}>
      <Logo theme="Light" />
      {pageContentCollection?.map((item, index) => {
        if (item.__typename) {
          return (
            <div
              {...inspectorProps({ fieldId: "pageContent" })}
              className="md::col-span-8 z-10 col-span-4 grid lg:col-span-12"
              key={item.sys?.id || index}
            >
              <DynamicComponent
                type={item.__typename as DynamicComponentKey}
                parameters={{
                  ...item,
                }}
              />
            </div>
          );
        }
      })}
    </PageContextProvider>
  );
}
